(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bim-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bim-countdown')) {
    class BimCountdown extends HTMLElement {
      connectedCallback() {
        this.endsAt = Number(this.dataset.endsAt) * 1000;
        this.urgentMs = Number(this.dataset.urgentHours) * 3600 * 1000;
        if (!Number.isFinite(this.endsAt)) return;
        this.units = Object.fromEntries(
          [...this.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el])
        );
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = this.endsAt - Date.now();
        if (left <= 0) {
          clearInterval(this.timer);
          this.classList.add('is-ended');
          this.querySelector('.bim-countdown__time')?.setAttribute('hidden', '');
          this.querySelector('.bim-countdown__head')?.setAttribute('hidden', '');
          this.querySelector('.bim-countdown__ended')?.removeAttribute('hidden');
          return;
        }
        const total = Math.floor(left / 1000);
        const values = {
          d: Math.floor(total / 86400),
          h: Math.floor((total % 86400) / 3600),
          m: Math.floor((total % 3600) / 60),
          s: total % 60,
        };
        for (const [unit, el] of Object.entries(this.units)) {
          el.textContent = unit === 'd' ? String(values[unit]) : String(values[unit]).padStart(2, '0');
        }
        this.classList.toggle('is-urgent', left <= this.urgentMs);
      }
    }
    customElements.define('bim-countdown', BimCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bim-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bim-delivery-estimate')) {
    class BimDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const target = this.querySelector('[data-bim-delivery-range]');
        const min = Number(this.dataset.minDays);
        const max = Number(this.dataset.maxDays);
        if (!target || !Number.isFinite(min) || !Number.isFinite(max)) return;

        const addBusinessDays = (days) => {
          const date = new Date();
          let added = 0;
          while (added < days) {
            date.setDate(date.getDate() + 1);
            const day = date.getDay();
            if (day !== 0 && day !== 6) added += 1;
          }
          return date;
        };

        let format;
        try {
          format = new Intl.DateTimeFormat(this.dataset.locale || undefined, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
          });
        } catch {
          format = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
        }

        const from = format.format(addBusinessDays(Math.min(min, max)));
        const to = format.format(addBusinessDays(Math.max(min, max)));
        target.textContent = from === to ? from : `${from} – ${to}`;
      }
    }
    customElements.define('bim-delivery-estimate', BimDeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
